require('initializers/gettext').default(__TRANSLATIONS__.gettext.ja); // eslint-disable-line no-undef
require('initializers/i18n').default('ja', __TRANSLATIONS__.i18n.ja); // eslint-disable-line no-undef

require('locales/dependencies');

require('select2/dist/js/i18n/ja');
require('jquery-ui/ui/i18n/datepicker-ja');
require('moment/locale/ja');
